import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from "@angular/core";

@Component({
  selector: "terra-name-icon",
  templateUrl: "./name-icon.component.html",
  styleUrls: ["./name-icon.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NameIconComponent implements OnInit {
  @Input() names: string[] = [];
  @Input() colors: string[] = ["#EBECFD"];
  @Input() icon: string = "";
  @Input() svgIcon: string = "";

  constructor() {}

  ngOnInit(): void {}

  get getText(): string {
    if (this.names !== null && this.names.length > 0) {
      return this.names.map((n) => n?.charAt(0)).join("");
    }
    return "";
  }

  get getColor(): string {
    return this.colors[Math.floor(Math.random() * this.colors.length)];
  }
}
